(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[902],{

/***/ "5Rjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "NavigationLargeSubNav", function() { return /* binding */ NavigationLargeSubNav_NavigationLargeSubNav; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.themes.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var themes = {
  "default": function _default(_ref) {
    var hasLink = _ref.hasLink,
        isHovering = _ref.isHovering;
    return {
      thRoot: '',
      thLink: classnames_default()('bg-black block overflow-hidden relative rounded-12', {}),
      thThumbnail: classnames_default()({
        'duration-250 ease-in': hasLink,
        'opacity-50 scale-105 ': hasLink && isHovering
      }),
      thLabel: classnames_default()('absolute px-5 text-center text-16 text-shadow-1 text-white transform -translate-y-1/2 w-full', {
        'top-1/2': !isHovering,
        'top-9/20': isHovering
      }),
      thLabelStyle: _objectSpread({}, isHovering ? {
        top: '45%',
        transition: 'all ease-in 0.25s'
      } : {
        top: '50%',
        transition: 'all ease-in 0.25s 0.15s'
      }),
      thSeeMoreLabel: 'absolute flex items-center justify-center leading-1 text-center text-shadow-1 text-white uppercase w-full',
      thSeeMoreLabelStyle: _objectSpread({
        fontSize: '0.6875rem'
      }, isHovering ? {
        bottom: '30%',
        opacity: 1,
        transition: 'all ease-in 0.15s 0.2s'
      } : {
        bottom: '27%',
        opacity: 0,
        transition: 'all ease-in 0.15s'
      }),
      thSeeMoreIcon: 'mx-5',
      thSeeMoreIconSize: '0.625rem',
      thBody: 'p-10'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.jsx


var __jsx = react_default.a.createElement;









var ThumbnailNavigation_ThumbnailNavigation = function ThumbnailNavigation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      link = _ref.link,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      thumbnail = _ref.thumbnail;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  if (!thumbnail.imageUrl) {
    return null;
  }

  var hasLink = link === null || link === void 0 ? void 0 : link.url;

  var _themes$theme = themes[theme]({
    hasLink: hasLink,
    isHovering: isHovering
  }),
      thBody = _themes$theme.thBody,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot,
      thSeeMoreIcon = _themes$theme.thSeeMoreIcon,
      thSeeMoreIconSize = _themes$theme.thSeeMoreIconSize,
      thSeeMoreLabel = _themes$theme.thSeeMoreLabel,
      thSeeMoreLabelStyle = _themes$theme.thSeeMoreLabelStyle,
      thThumbnail = _themes$theme.thThumbnail;

  var onEnter = hasLink ? function () {
    return setHovering(true);
  } : null;
  var onLeave = hasLink ? function () {
    return setHovering(false);
  } : null;
  return __jsx("div", {
    className: classnames_default()(className, thRoot, 'h-full')
  }, __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: hasLink ? DynamicLink["a" /* default */] : 'div',
    className: thLink,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave,
    onFocus: onEnter,
    onBlur: onLeave
  }), __jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: thThumbnail,
    ratioKey: thumbnail.ratioKey || ratios_utils["c" /* default */].XL,
    ratioDisplay: 1 / 4
  })), !!label && __jsx("span", {
    className: thLabel,
    style: thLabelStyle
  }, label), !!seeMoreLabel && __jsx("span", {
    className: thSeeMoreLabel,
    style: thSeeMoreLabelStyle
  }, seeMoreLabel, __jsx(Icon["a" /* Icon */], {
    className: thSeeMoreIcon,
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: thSeeMoreIconSize
  }))), !!children && !!react["Children"].count(children) && __jsx("div", {
    className: thBody
  }, children));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/subnavs/NavigationLargeSubNav.jsx




var NavigationLargeSubNav_jsx = react_default.a.createElement;









var NavigationLargeSubNav_NavigationLargeSubNav = function NavigationLargeSubNav(_ref) {
  var _ref$subItems = _ref.subItems,
      subItems = _ref$subItems === void 0 ? [] : _ref$subItems;

  if (isEmpty_default()(subItems)) {
    return null;
  }

  return NavigationLargeSubNav_jsx("div", {
    className: "bg-white overflow-y-auto px-50 py-25 rounded-b",
    style: {
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }, NavigationLargeSubNav_jsx("ul", {
    className: "gap-20 grid grid-cols-4"
  }, subItems.map(function (item) {
    var _item$thumbnail;

    var thumbnail = {
      imageUrl: ((_item$thumbnail = item.thumbnail) === null || _item$thumbnail === void 0 ? void 0 : _item$thumbnail.imageUrl) || '',
      ratioKey: !isEmpty_default()(item.subItems) ? ratios_utils["c" /* default */].S : ratios_utils["c" /* default */].XL
    };
    return NavigationLargeSubNav_jsx("li", {
      key: item.label
    }, NavigationLargeSubNav_jsx(ThumbnailNavigation_ThumbnailNavigation, {
      label: item.label,
      link: isEmpty_default()(item.subItems) ? item.link : null,
      seeMoreLabel: item.seeMoreLabel,
      thumbnail: thumbnail
    }, !isEmpty_default()(item.subItems) && NavigationLargeSubNav_jsx(react["Fragment"], null, NavigationLargeSubNav_jsx("ul", {
      className: "font-bold font-sans text-black text-12"
    }, (item.subItems || []).map(function (subitem) {
      return subitem.label ? NavigationLargeSubNav_jsx("li", {
        key: subitem.label
      }, NavigationLargeSubNav_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, subitem.link, {
        as: DynamicLink["a" /* default */],
        className: "inline-block no-underline py-5 text-black hocus:text-black-active transition-color",
        "data-testid": "NavigationLargeSubNav-third-link"
      }), subitem.label)) : null;
    })), item.seeMoreLabel && NavigationLargeSubNav_jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, item.link, {
      className: "mt-10",
      color: colors["a" /* COLORS */].MEDIUM_GREY,
      iconName: icons["a" /* ICONS */].ARROW_TAIL_RIGHT,
      label: item.seeMoreLabel,
      trackingData: item.link.trackingData
    })))));
  })));
};

/***/ })

}]);